export const API_URL = window.location.hostname === 'localhost' ? "http://localhost:9080/api" : "https://api.dev.sensoreal.com.au/api";
export const ASSETS_HOST = window.location.hostname === 'localhost' ? 'http://localhost:9084/' : "https://assets.dev.sensoreal.com.au/"; 
export default API_URL;
